import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appScrollAnimate]'
})
export class ScrollAnimateDirective implements OnInit, OnDestroy {
  @Input('appScrollAnimate') animationClass: string = 'animate__fadeInUp'; // Default animation class
  @Input() infinite: boolean = false; // Flag to make animation infinite

  private observer: IntersectionObserver | undefined;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.setupIntersectionObserver();
    }, 100);
  }

  private setupIntersectionObserver() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.addAnimationClass();
        this.observer?.unobserve(this.el.nativeElement);
      }
    }, {
      threshold: 0.1
    });

    this.observer.observe(this.el.nativeElement); 
  }

  private addAnimationClass() {
    this.el.nativeElement.classList.add('animate__animated', this.animationClass);

    if (this.infinite) {
      this.el.nativeElement.style.animationIterationCount = 'infinite'; 
    }

    this.el.nativeElement.addEventListener('animationend', () => {
      if (!this.infinite) {
        this.el.nativeElement.classList.remove(this.animationClass); 
      }
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
